import { useEffect, useState } from "react";
import { getNotifications } from "../../services/get.service";
import { notification } from "../type";
import { joinGroup } from "../../services/post.service";

export interface IUseNotificationReturnType {
  loading: boolean;
  notifications: notification[] | null;
  notificationsCount: number;
}

export const useNotification = (setFCount: (nu: number) => void): IUseNotificationReturnType => {
  const [loading, setLoading] = useState(true);
  const [notifications, setNotifications] = useState<notification[]>([]);

  useEffect(() => {
    joinGroup()
      .then(() => {
        console.log('joined')
        getNotifications()
          .then((res) => {
            setLoading(false);
            setNotifications(res.data);
          })
          .catch((err) => {
            setLoading(false);
            console.error(err);
          });
      }).catch((err) => {
        console.log(err)
      })
  }, []);

  var notificationsCount =
    notifications?.filter((notification) => !notification.seen).length | 0;
  setFCount(notificationsCount)

  return { loading, notifications, notificationsCount };
};
